/*
 * Raid Supply - sitewide colour image swatches (09-09-2026)
 * ---------------------------------------------------------
 * The custom product module (#pdm) renders its colour option as a dropdown on
 * every template except product.battalion-rucksack.json, which has its own
 * swatch build. This upgrades that dropdown, on any template, into a row of
 * square tiles showing each colour's own product photo.
 *
 * How it works: the swatch row drives the original <select>. Clicking a tile
 * sets the select's value and fires a change event, so all of the module's
 * existing logic (price, stock wording, gallery, add to basket, back-in-stock
 * form) keeps working untouched. The select stays in the DOM, visually hidden.
 *
 * Deliberate: sold-out colours keep a normal, full-colour, clickable tile.
 * They are never greyed out, disabled or hidden - selecting one is what
 * surfaces the back-in-stock form.
 *
 * Safe to delete: remove the "Raid colour swatches" section from the header
 * group and the page falls straight back to the dropdown.
 */
(function () {
  if (window.raidColourSwatches) { return; }
  window.raidColourSwatches = true;

  var ORDER = ['multicam', 'mtp', 'black', 'olivegreen', 'olive', 'odgreen', 'od', 'coyote', 'tan', 'dpm'];
  var CSS = [
    '.rs-swatches{display:flex;flex-wrap:wrap;gap:10px;margin-top:2px}',
    '.rs-swatch{position:relative;width:64px;height:64px;padding:3px;flex:0 0 auto;background:#fff;',
    'border:1px solid #b5b2a9;border-radius:0;cursor:pointer;overflow:hidden;',
    'transition:border-color .15s ease,box-shadow .15s ease;-webkit-tap-highlight-color:transparent}',
    '.rs-swatch img{width:100%;height:100%;object-fit:contain;display:block}',
    '.rs-swatch-txt{display:flex;align-items:center;justify-content:center;width:100%;height:100%;',
    'font-size:.85rem;font-weight:800;letter-spacing:.04em;color:#55534d}',
    '.rs-swatch:hover{border-color:#4b5320}',
    '.rs-swatch.rs-on{border-color:#4b5320;box-shadow:inset 0 0 0 2px #4b5320}',
    '.rs-swatch:focus-visible{outline:2px solid #0d0d0d;outline-offset:2px}',
    '.rs-swatch-value{font-weight:700;color:#0d0d0d;text-transform:none;letter-spacing:0}',
    '.rs-hidden-select{position:absolute!important;width:1px;height:1px;margin:-1px;padding:0;',
    'overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0}',
    '@media screen and (max-width:900px){.rs-swatch{width:58px;height:58px}}'
  ].join('');

  function injectCss() {
    if (document.getElementById('rs-swatch-css')) { return; }
    var s = document.createElement('style');
    s.id = 'rs-swatch-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function norm(v) { return String(v == null ? '' : v).toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function isColour(v) { return /colou?r/i.test(String(v || '')); }
  function rank(v) {
    var n = norm(v);
    for (var i = 0; i < ORDER.length; i++) { if (ORDER[i] === n) { return i; } }
    return ORDER.length;
  }
  function sized(url, w) {
    if (!url) { return null; }
    return url.indexOf('?') === -1 ? url + '?width=' + w : url + '&width=' + w;
  }

  /* Build value -> image url from the module's own JSON payload. */
  function imagesFromPayload() {
    var el = document.getElementById('pdm-data');
    if (!el) { return null; }
    var data;
    try { data = JSON.parse(el.textContent); } catch (e) { return null; }
    if (!data || !data.variants || !data.variants.length) { return null; }
    var names = data.options || [];
    var oi = -1;
    for (var i = 0; i < names.length; i++) { if (isColour(names[i])) { oi = i; break; } }
    if (oi === -1) { return null; }
    var byId = {};
    (data.media || []).forEach(function (m) { byId[m.id] = m; });
    var map = {}, order = [];
    data.variants.forEach(function (v) {
      var val = v.options ? v.options[oi] : null;
      if (val == null || Object.prototype.hasOwnProperty.call(map, val)) { return; }
      var m = v.media_id ? byId[v.media_id] : null;
      map[val] = m ? (m.thumb || m.src) : null;
      order.push(val);
    });
    return { map: map, order: order, handle: data.handle };
  }

  /* Anything the payload could not supply (variant photo outside the module's
     first 10 media items) is filled in from the product JSON endpoint. */
  function fillGaps(info, done) {
    var missing = info.order.filter(function (v) { return !info.map[v]; });
    if (!missing.length || !info.handle) { done(); return; }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') { root += '/'; }
    window.fetch(root + 'products/' + info.handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) { return; }
        var oi = -1;
        (p.options || []).forEach(function (o, i) {
          var n = typeof o === 'string' ? o : o.name;
          if (oi === -1 && isColour(n)) { oi = i; }
        });
        if (oi === -1) { return; }
        p.variants.forEach(function (v) {
          var val = v.options ? v.options[oi] : null;
          if (val == null || info.map[val]) { return; }
          if (v.featured_image && v.featured_image.src) { info.map[val] = sized(v.featured_image.src, 180); }
        });
      })
      .catch(function () {})
      .then(done, done);
  }

  function upgrade(select, info) {
    var field = select.closest('.pdm__field') || select.parentElement;
    if (!field || field.querySelector('.rs-swatches') || field.querySelector('.pdm__swatches')) { return; }

    var label = field.querySelector('.pdm__label');
    var chosen = null;
    if (label) {
      if (label.textContent.slice(-1) !== ':') { label.textContent = label.textContent.replace(/:\s*$/, '') + ': '; }
      chosen = document.createElement('span');
      chosen.className = 'rs-swatch-value';
      label.appendChild(chosen);
    }

    var values = [];
    for (var i = 0; i < select.options.length; i++) { values.push(select.options[i].value); }
    values.sort(function (a, b) {
      var d = rank(a) - rank(b);
      return d !== 0 ? d : values.indexOf(a) - values.indexOf(b);
    });

    var row = document.createElement('div');
    row.className = 'rs-swatches';
    row.setAttribute('role', 'radiogroup');
    row.setAttribute('aria-label', select.getAttribute('aria-label') || 'Colour');

    var buttons = [];
    values.forEach(function (val) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rs-swatch';
      btn.setAttribute('role', 'radio');
      btn.dataset.value = val;
      btn.title = val;
      btn.setAttribute('aria-label', val);
      var src = info.map[val];
      if (src) {
        var img = document.createElement('img');
        img.src = src;
        img.alt = '';
        img.loading = 'lazy';
        btn.appendChild(img);
      } else {
        var t = document.createElement('span');
        t.className = 'rs-swatch-txt';
        t.textContent = String(val).slice(0, 2).toUpperCase();
        btn.appendChild(t);
      }
      btn.addEventListener('click', function () {
        select.value = val;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        paint();
      });
      buttons.push(btn);
      row.appendChild(btn);
    });

    function paint() {
      for (var i = 0; i < buttons.length; i++) {
        var on = buttons[i].dataset.value === select.value;
        buttons[i].classList.toggle('rs-on', on);
        buttons[i].setAttribute('aria-checked', on ? 'true' : 'false');
        buttons[i].tabIndex = on ? 0 : -1;
      }
      if (chosen) { chosen.textContent = select.value; }
    }

    row.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k !== 'ArrowRight' && k !== 'ArrowLeft' && k !== 'ArrowDown' && k !== 'ArrowUp') { return; }
      e.preventDefault();
      var idx = 0;
      for (var i = 0; i < buttons.length; i++) { if (buttons[i].dataset.value === select.value) { idx = i; break; } }
      var step = (k === 'ArrowRight' || k === 'ArrowDown') ? 1 : -1;
      var next = buttons[(idx + step + buttons.length) % buttons.length];
      select.value = next.dataset.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      paint();
      next.focus();
    });

    select.addEventListener('change', paint);
    select.classList.add('rs-hidden-select');
    select.setAttribute('tabindex', '-1');
    select.setAttribute('aria-hidden', 'true');
    field.insertBefore(row, select);
    paint();
  }

  function scan() {
    var host = document.getElementById('pdm-options');
    if (!host) { return false; }
    var selects = host.querySelectorAll('select.pdm__select:not(.rs-hidden-select)');
    if (!selects.length) { return false; }
    var target = null;
    for (var i = 0; i < selects.length; i++) {
      var f = selects[i].closest('.pdm__field');
      var name = (selects[i].getAttribute('aria-label') || '') + ' ' + (f && f.querySelector('.pdm__label') ? f.querySelector('.pdm__label').textContent : '');
      if (isColour(name)) { target = selects[i]; break; }
    }
    if (!target) { return false; }
    var info = imagesFromPayload();
    if (!info) { return false; }
    injectCss();
    fillGaps(info, function () { upgrade(target, info); });
    return true;
  }

  function start() {
    if (scan()) { return; }
    var tries = 0;
    var timer = window.setInterval(function () {
      tries++;
      if (scan() || tries > 40) { window.clearInterval(timer); }
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();